import { assetAvailability } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
    getAssetsAvailabilityStats(params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(assetAvailability.assetAvailabilitybase, {
                    params: params,
                })
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    getTypeWiseVehicleAvailabilityChart(params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(assetAvailability.vehicleTypeWiseAvalabilityChartBase, {
                    params: params,
                })
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
     getTypeWiseNewVehicleAvailabilityChart(params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(assetAvailability.vehicleTypeWiseNewAvalabilityChartBase, {
                    params: params,
                })
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    

    getNextVehicleAvailabilityChart(params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(assetAvailability.nextVehicleAvalabilityChartBase, {
                    params: params,
                })
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },

});